<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs :breadcrumbstitle="breadcrumbstitle" :breadcrumbsData="breadcrumbsData"/>
      <div class="content mt-3">
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>

        <div class="animated fadeIn" v-if="this.hasRole">
          <!-- content place -->


          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('Contract.title')}}</strong>
                <div class="float-right">
                  <router-link :to="{ path: '/Contracts'}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i> {{$t('Contracts.title')}}</router-link>
                  &nbsp;
                  <!--<span class="btn btn-primary btn-sm" v-on:click="emptyForNew()"><i class="fa fa-link"></i> {{$t('Contract.new')}}</span>-->
                </div>
              </div>
              <div class="card-body card-block">
                <!--<AlertInPage />-->
                <!--<AlertInPage type="success" msg="msg" delay="2000"/>-->
                <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">



                  <div class="row">
                    <div class="col-12 col-md-12 d-block d-xs-none d-sm-none d-md-none d-lg-none d-xl-none">
                      <template v-if="data && data.id">
                        <!--<template v-if="!hasAccountant">-->

                          <FileUploader :textInBtn="$t('InvoiceInbound.imageupload')" classNameContainer="d-block overflow-hidden" className="form-control" :dataid="data.id" :datatype="'contract'" :handlerSuccess="fileUploadHadler"></FileUploader>
                          <!--<template v-if="hasnav && !hasAccountant">-->
                            <!--<div v-if="images.length<1" class="alert alert-danger">-->
                              <!--{{ $t('InvoiceInbound.no_image_error') }}-->
                            <!--</div>-->
                          <!--</template>-->
                        <!--</template>-->
                      </template>

                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-12 d-block d-xs-none d-sm-none d-md-none d-lg-none d-xl-none">
                      <div class="col col-12X">
                        <ImageDisplayer classNameContainer="d-block overflow-hidden" :haveToDownload="true" className="form-control" :dataid="data.id" :datatype="'contract'" :handlerSuccess="imageClickHadler"
                                        :cbDataChange="cbDataChange"></ImageDisplayer>
                      </div>
                    </div>
                  </div>


                  <div class="row form-group">
                    <div class="col col-md-3"><label for="identifier" class=" form-control-label">{{ $t('Contract.identifier') }} ({{ $t('validator.required') }}) </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.identifier" type="text" id="identifier" placeholder="" class="form-control" name="data.identifier"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.identifier')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="title" class=" form-control-label">{{ $t('Contract.ptitle') }} </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.title" type="text" id="title" placeholder="" class="form-control" name="data.title"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.title')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="dt_make" class=" form-control-label">{{ $t('Document.dt_make') }} ({{ $t('validator.required')
                      }})</label>
                    </div>
                    <div class="col-12 col-md-9">
                      <InputText type="DatetimepickerBp"
                                 id="dt_make" name="data.dt_make" v-model="data.dt_make" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:true}" hasToKeyboard="auto" value=""
                                 :title="$t('Document.dt_make')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_make')"
                      />
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="price_sum_net" class=" form-control-label">{{ $t('Contract.price_sum_net') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.price_sum_net" type="text" id="price_sum_net" placeholder="" class="form-control" name="data.price_sum_net"
                             v-validate="'numberprice'" v-bind:class="{'is-invalid':errors.has('data.price_sum_net')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="price_sum_gross" class=" form-control-label">{{ $t('Contract.price_sum_gross') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.price_sum_gross" type="text" id="price_sum_gross" placeholder="" class="form-control" name="data.price_sum_gross"
                             v-validate="'numberprice'" v-bind:class="{'is-invalid':errors.has('data.price_sum_gross')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group     d-none d-xs-block d-sm-block d-md-block d-lg-block d-xl-block">
                    <div class="col col-4">
                      <ImageDisplayer classNameContainer="d-block overflow-hidden" :haveToDownload="true" className="form-control" :dataid="data.id" :datatype="'contract'"
                                      :handlerSuccess="imageClickHadler"></ImageDisplayer>
                    </div>
                    <div class="col col-8">
                      <div class="row">
                        <div class="col-12">
                          <div class="row form-group">
                            <div class="col col col-6"><label class=" form-control-label">{{ $t('global.fileupload') }}</label>
                            </div>
                            <div class="col col col-6">
                              <FileUploader :textInBtn="$t('InvoiceInbound.imageupload')" classNameContainer="d-block overflow-hidden" className="form-control" :dataid="data.id" :datatype="'contract'" :handlerSuccess="fileUploadHadler"></FileUploader>
                            </div>
                            <div class="col col-12">
                              <!--<ImageDisplayer classNameContainer="d-block overflow-hidden" className="form-control" :dataid="data.id" :datatype="'invoiceinbound'" :handlerSuccess="imageClickHadler"></ImageDisplayer>-->
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--<div class="row">-->
                        <!--<div class="col-12">-->
                          <!--<span v-for="image in images" class="image">{{image}}</span>-->
                        <!--</div>-->
                      <!--</div>-->
                      <hr>
                    </div>
                  </div>

                </form>
              </div>

              <div class="card-footer">
                <button type="submit" class="btn btn-primary btn-sm" v-on:click="save()">
                  <i class="fa fa-dot-circle-o"></i> {{$t('global.save')}}
                </button>
                <!--<button type="reset" class="btn btn-danger btn-sm">-->
                <!--<i class="fa fa-ban"></i> Reset-->
                <!--</button>-->
              </div>

            </div>

          </div>


        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>

</template>

<script>

  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import HelperRole from '@/helper/HelperRole';
  import MenuToggle from '@/components/MenuToggle.vue';
  import InputText from '@/components/InputText.vue';
  import ImageDisplayer from '@/components/ImageDisplayer.vue';
  import FileUploader from '@/components/FileUploader.vue';


  //  id_store 	wsid 	text
  export default {
    name: 'Contract',
    data() {
      return {
        Helper: Helper

        , data: {
          // cardinality 	Contract_text 	deleted
          "id": "",
          "identifier": "",
          "title": "",
          "dt_make": "",
          "price_sum_net": "",
          "price_sum_gross": "",
        }
        , dataBase: { // need for change without save
          "id": "",
          "identifier": "",
          "title": "",
          "dt_make": "",
          "price_sum_net": "",
          "price_sum_gross": "",
        }
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 5000,
        }
        , breadcrumbstitle: 'Contract.title'
        , breadcrumbsData: [
          {
            'title': "Contract.title",
            'url': "Contract",
          },
          {
            'title': "Contract.title",
          }
        ]
        , images: []
        , HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""

      };
    },
    props: {
      id: String,
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
          this.getElement();
        }
      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },

      '$route.params': function (newdata, olddata) {
        if (this.$route.params.id) {
          this.id = newdata;
          this.getElement();
        } else {
          this.id = void 0;
        }
      }
    },
    mounted() {
      const modul = this;
      modul.handleRights();
    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [14], [16, 20])) {
          modul.hasRole = true;
        }
        if (modul.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
        }
      },
      init(){
        const modul = this;
        modul.getElement();
      },
      cbDataChange(data){
        const modul = this;
        modul.images = data
        console.log("cbDataChange - data");
        console.log(data);
      },
      getElement(){
        const modul = this;
        let id = 0;
        try {
          id = (this.$route.params.id);
          if (id) {
            modul.AlertInPage.msg = "form.in_progress";
            modul.AlertInPage.type = "warning";
            Api.getContract({id: id, id_company: modul.state.id_company}).then(function (res) {
              console.log(res);
              if (res && res.result && res.data) {
                modul.data = res.data;
                modul.AlertInPage.msg = "";
              } else {
//                modul.data = Object.assign({}, modul.dataBase);
                modul.hasRole = false;
                modul.AlertInPage.msg = "form.error";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
//                  modul.$router.push({path: "/contracts"})
                }, Number(2000));
              }
            }, function (e) {
              modul.AlertInPage.msg = "form.error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(modul.AlertInPage.delay));
            });
          }
        } catch (e) {
          console.log(e);
        }
      },
      emptyForNew(){
        this.data = Object.assign({}, this.dataBase);
        this.$router.push({name: "/contract"})
      },
      save(){
        const modul = this;
        modul.$validator.validateAll().then((result) => {
          if (result) {
            const req = {};
            req.data = Helper.makeFilteredObjectByKeys(modul.data, ["id", "identifier", "title", "dt_make", "price_sum_net", "price_sum_gross"]);
            req.id_company = modul.state.id_company;
            modul.AlertInPage.msg = "form.in_progress";
            modul.AlertInPage.type = "warning";
            Api.saveContract(req).then(function (res) {
              if (res && res.result) {
                if (res && res.data.id) {
                  modul.data.id = res.data.id;
                  modul.data.price_sum_net = (Helper.String(res.data.price_sum_net).length > 0) ? Helper.String(res.data.price_sum_net) : modul.data.price_sum_net;
                  modul.data.price_sum_gross = (Helper.String(res.data.price_sum_gross).length > 0) ? Helper.String(res.data.price_sum_gross) : modul.data.price_sum_gross;
                }
                modul.AlertInPage.msg = "form.save_succes";
                modul.AlertInPage.type = "success";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
              } else {
                modul.AlertInPage.msg = "form.save_error";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
              }
            }, function (e) {
              modul.AlertInPage.msg = "form.save_error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(modul.AlertInPage.delay));
            });

          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
          }
        });
      },
      fileUploadHadler(e){
        console.log("e");
        console.log(e);
      },
      imageClickHadler(e){
        console.log("e");
        console.log(e);
      },
    },
    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      AlertInPage,
      InputText,
      ImageDisplayer,
      FileUploader,
      MenuToggle
    },
  };
</script>








